export default {
  path: '/trainCampPlan',
  name: 'trainCampPlan',
  redirect: '/trainCampPlan/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'enrollList',
      component: () => import('@/views/trainCampEnroll'),
      meta: { requiresAuth: true }
    },
    {
      path: 'enrollAdd',
      component: () => import('@/views/trainCampEnroll/add'),
      meta: { requiresAuth: true }
    },
    {
      path: 'trainCampEnrollInfo',
      component: () => import('@/views/trainCampEnroll/info'),
      meta: { requiresAuth: true }
    },
    {
      path: 'infoToYouthEnroll',
      component: () => import('@/views/trainCampEnroll/infoToYouth'),
      meta: { requiresAuth: true }
    },
    {
      path: 'submitPlayerEnroll',
      component: () => import('@/views/trainCampEnroll/submitPlayer'),
      meta: { requiresAuth: true }
    },
  ]
}
